import { getEnvState } from "JavaScripts/state"

export const getIsPanelistDomain = () =>
  getEnvState().PANELIST_DOMAIN?.startsWith(window.location.hostname)
